/*
 * @Author: liyaoshi liyaoshi@sohu-inc.com
 * @Description: 海外文章页广告处理
 */
import MptcfeWapAd from "mptcfe-wap-ad";
import Utils from "@/utils/util.js";
import { articleAbroadAdConfig } from "@/config/adConfig";
import { getOdinData } from "@/js/request/odinRequest";
import adSspExposure from "../sspRequest/adExposure.js"
import { getMiddleInsertBeforeDom } from "@/utils/element"
import Helper from "../../utils/helper"

// 广告模板组件
import videoTxtAd from "../components/videoTxtAd.vue" // 视频广告
const AdGenerator = MptcfeWapAd.AdGenerator;
/**
 * @description 新增momagic广告
 */
export const addMomagicAd = async function () {
    const adConfig = articleAbroadAdConfig.momagicAd
    if(!adConfig) return
    const { resourceId, spmCCode, posCode, rule, fixArray } = adConfig;
    const param = {
        resourceId,
        spmCCode,
        adInfo: {
            posCode,
            rule,
            fixArray,
        },
        isSingleAd: true,
    }
    try {
        const data = await getOdinData(param)
        const list = data?.list
        const adData = list?.[0]?.resourceData
        if(!adData) return
        new AdGenerator({
            data: adData,
            location: `${spmCCode}.1`,
            resourceId: resourceId,
            success: function (adDom) {
                //插入固定位置
                if (adData) {
                    document.getElementsByTagName("body")[0].append(adDom);
                }
                //触发打码
                Utils.domDidChange({
                    target: spmCCode,
                })
            },
        })
    } catch (error) {
        console.log('momagic广告异常', error)
    }
}

/**
 * @description 分享下方评论上方Taboola广告
 */
export const shareBottomTaboolaAd = async function () {
    const adConfig = articleAbroadAdConfig.shareBottomTaboola
    if(!adConfig) return
    const { resourceId, spmCCode, posCode, rule, fixArray } = adConfig
    const param = {
        resourceId,
        spmCCode,
        adInfo: {
            posCode,
            rule,
            fixArray,
        },
        isSingleAd: true,
    }
    try {
        const data = await getOdinData(param)
        const list = data?.list
        const adData = list?.[0]?.resourceData
        if(!adData) return
        new AdGenerator({
            data: adData,
            location: spmCCode,
            resourceId: resourceId,
            success: (adDom) => {
                adDom && document.querySelector("#taboolaContainer")?.appendChild(adDom)
            },
        })
    } catch (error) {
        console.log('分享下方评论上方Taboola广告异常', error)
    }
}

/**
 * @description 文末和分享上方Onemob广告
 */
export const shareTopOneMobAd = async function () {
    const adConfig = articleAbroadAdConfig.shareTopOneMob
    if(!adConfig) return
    const { resourceId, spmCCode, posCode, rule, fixArray } = adConfig
    const param = {
        resourceId,
        spmCCode,
        adInfo: {
            posCode,
            rule,
            fixArray,
        },
        isSingleAd: true,
    }
    try {
        const data = await getOdinData(param)
        const list = data?.list
        const adData = list?.[0]?.resourceData
        if(!adData) return
        new AdGenerator({
            data: adData,
            location: spmCCode,
            resourceId: resourceId,
            success: (adDom) => {
                adDom && document.querySelector("#onemobContainer")?.appendChild(adDom)
            },
        })
    } catch (error) {
        console.log('onemob广告异常', error)
    }
}

/**
 * @description 中插广告
 */
export const middleInsertAd = async function () {
    const adConfig = articleAbroadAdConfig.articleMiddleAd
    const { resourceId, spmCCode, posCode, rule, fixArray } = adConfig
    const param = {
        resourceId,
        spmCCode,
        adInfo: {
            posCode,
            rule,
            fixArray,
        },
        isSingleAd: true,
    }
    try {
        const data = await getOdinData(param)
        const list = data?.list
        const adData = list?.[0]?.resourceData
        if(!adData) return
        let anAnchor = getMiddleInsertBeforeDom()
        new AdGenerator({
            data: adData,
            containerId: "middleInsertAd",
            params: {
                id: "middle",
            },
            location: spmCCode,
            resourceId: resourceId,
            success: (adDom) => {
                let adDomWrapper = document.createElement("div")
                adDomWrapper.className = "middle-mon-content"
                adDomWrapper.appendChild(adDom)
                Helper.insertAfter(adDomWrapper, anAnchor)
            },
        })
    } catch (error) {
        console.log('中插广告', error)
    }
}

/**
 * @description 底部广告（百度通栏/大图广告，位于网站地图上方）
 */
export const bottomBannerAd = async function () {
    const adConfig = articleAbroadAdConfig.bottomBanner
    if(!adConfig) return
    const { resourceId, spmCCode, posCode, rule, fixArray } = adConfig
    const param = {
        resourceId,
        spmCCode,
        adInfo: {
            posCode,
            rule,
            fixArray,
        },
        isSingleAd: true,
    }
    try {
        const data = await getOdinData(param)
        const list = data?.list
        const adData = list?.[0]?.resourceData
        if(!adData) return
        //若为新品算广告，且超时时间未设置则设置为700ms
        if (adData.adType === MptcfeWapAd.AdType.XPS && !adData.adData.time) {
            adData.adData.time = 700
        }
        adData.adData && (adData.adData.lazy = false) // 去掉懒加载
        const creativeType = adData.adData?.creativeType
        const bottomBannerAdTemplate = {
            VideoTxt: videoTxtAd,
        }
        const component = bottomBannerAdTemplate[creativeType]
        new AdGenerator({
            data: adData,
            location: spmCCode,
            resourceId: resourceId,
            component: component,
            success: function (adDom) {
                //添加SSP相关打码信息
                adDom = adSspExposure(adDom, adData)
                //插入固定位置
                document.querySelector("#bottomBanner").appendChild(adDom)
                //触发打码
                Utils.domDidChange({ target: "b-mb" })
            },
        })
    } catch (error) {
        console.log('底部通栏广告异常', document.querySelector("#bottomBanner") ,error)
    }
}

/**
 * @description 文章页无固定位置vidoomy广告
 */
export const vidoomyAd = async function () {
    const adConfig = articleAbroadAdConfig.vidoomyAd
    if(!adConfig) return
    const { resourceId, spmCCode, posCode, rule, fixArray } = adConfig
    const param = {
        resourceId,
        spmCCode,
        adInfo: {
            posCode,
            rule,
            fixArray,
        },
        isSingleAd: true,
    }
    try {
        const data = await getOdinData(param)
        const list = data?.list
        const adData = list?.[0]?.resourceData
        if(!adData) return
        new AdGenerator({
            data: adData,
            location: spmCCode,
            resourceId: resourceId,
            success: (adDom) => {
                console.log("vidoomyAd广告 adDom", adDom)
                adDom && document.head.appendChild(adDom)
            },
        })
    } catch (error) {
        console.log('文章页vidoomy广告异常', error)
    }
}